/* ============================================================
   GOB — TREAT20 Halloween layer (V123, 15 Oct 2026)
   Elements: B03 hero · B04 collection tiles · B05 Halloween picks ·
             E01 Mayor Manor hero slide · E04 Shop menu card ·
             E05 search suggestions · E20 tab title + favicon ·
             P02 Light the manor popup (F01 / F02 photos)

   D2 — the code is never automatic.
     Sale prices show ONLY when TREAT20 sits on the shopper's cart:
       · they arrived from an ad / email link  /discount/TREAT20?redirect=…
       · or tapped "Apply code" (hero, popup), which uses the same link.
     Everyone else sees regular prices plus "20% off with TREAT20".
     Truth = /cart.js discount_codes (the code stays on the cart even after
     gob-discount-guard.js clears the cookie on an empty cart).
   D1 — never stacks with the Club. When html.gob-club-on is set (member or
     Club in cart) TREAT20 prices are not shown and the popup never opens.

   Window: 16 Oct 00:00 → 31 Oct 23:59 Vilnius time.
   Test before the 16th: add ?t20=preview to any URL (?t20=off to stop).
   ============================================================ */
(function () {
  'use strict';
  if (window.__gobT20) return; window.__gobT20 = true;

  var C = window.GOB_T20 || {};
  var CODE = C.code || 'TREAT20';
  var ROOT = C.root || '/';
  var START = Date.parse(C.start || '2026-10-15T22:40:00+03:00');
  var END = Date.parse(C.end || '2026-11-01T06:59:59Z');
  var IMG = C.img || {};
  var MANOR = C.manor || 'lego-mayor-manor-11383-light-kit';
  var H = document.documentElement;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  var qs = new URLSearchParams(location.search);
  if (qs.get('t20') === 'preview') ss('t20pv', '1');
  if (qs.get('t20') === 'off') ss('t20pv', null);
  var preview = ss('t20pv') === '1';
  var now = Date.now();
  if (!preview && (now < START || now > END)) return;
  H.classList.add('t20-on');

  /* ---------- helpers ---------- */
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(h) { var d = document.createElement('div'); d.innerHTML = h.trim(); return d.firstChild; }
  function pad(n) { return String(n).padStart(2, '0'); }
  /* V162: same rounding as Shopify (the discount is rounded down), so the price shown
     is the price charged: €79,99 → €64,00, not €63,99. */
  function off(c) { return c - Math.floor(c * 20 / 100); }

  var SYM = { EUR: '€', GBP: '£', USD: '$' }[C.currency] || '€';
  var DEC = C.currency === 'EUR' ? ',' : '.';
  (function () { qa('.d-price .visually-hidden, .grid-product__price--current .visually-hidden').slice(0, 1).forEach(function (n) { var m = n.textContent.match(/([€£$])\s?\d+([.,])\d{2}/); if (m) { SYM = m[1]; DEC = m[2]; } }); })();
  function money(c, sup) { var s = (c / 100).toFixed(2).split('.'); return SYM + s[0] + (sup ? '<sup>' + s[1] + '</sup>' : DEC + s[1]); }
  function cents(t) { t = String(t).replace(/\s/g, ''); var m = t.match(/[€£$](\d+)[.,](\d{2})/) || t.match(/(\d+)[.,](\d{2})[€£$]/); if (m) return (+m[1]) * 100 + (+m[2]); m = t.match(/[€£$](\d+)/); return m ? (+m[1]) * 100 : null; }
  function centsOf(node) { var vh = q('.visually-hidden', node); var c = vh ? cents(vh.textContent) : null; if (c == null) { var sup = q('sup', node); if (sup) { var main = node.textContent.replace(sup.textContent, '').replace(/[^\d]/g, ''); if (main) c = (+main) * 100 + (+sup.textContent.replace(/\D/g, '')); } } return c == null ? cents(node.textContent) : c; }

  var here = location.pathname + location.search.replace(/[?&]t20=[^&]*/, '').replace(/^&/, '?') + location.hash;
  function applyUrl(path) { return ROOT + 'discount/' + CODE + '?redirect=' + encodeURIComponent(path || here); }

  var PK = '<svg viewBox="0 0 26 24" aria-hidden="true"><rect x="11" y="0" width="4" height="5" rx="1" fill="#3E6B2E"/><rect x="1" y="5" width="24" height="18" rx="7" fill="#D86E12"/><rect x="9" y="5" width="2" height="18" fill="#B85A0E"/><rect x="15" y="5" width="2" height="18" fill="#B85A0E"/><path d="M6 11l2.5-3 2.5 3zM15 11l2.5-3 2.5 3z" fill="#FFF3C4"/><path d="M6 15h14l-2 3h-2l-1-1.5-2 1.5-2-1.5-1 1.5H8z" fill="#FFF3C4"/></svg>';

  /* ---------- D2 state ---------- */
  function club() { return H.classList.contains('gob-club-on') || H.hasAttribute('data-gob-member'); }
  var hasCode = ss('t20ap') === '1' || new RegExp('(?:^|;\\s*)discount_code=' + CODE + '(?:;|$)', 'i').test(document.cookie);
  function paint() {
    H.classList.toggle('t20-applied', hasCode && !club());
    H.classList.toggle('t20-club', club());
  }
  /* V162: TREAT20 and the GOB Club never stack (the Club's 30% wins). Shopify keeps the
     code on the cart but drops it at checkout while the Club is in the basket. If the
     shopper then takes the Club out again, put TREAT20 back once, so they are never left
     paying full price for a code they applied. A code the shopper removed themselves
     (no Club involved) is never re-added. Members (data-gob-member) are left alone. */
  var CLUB_PID = 10601114403149, reTried = false;
  function clubInCart(cart) { return ((cart && cart.items) || []).some(function (i) { return i.product_id === CLUB_PID; }); }
  function reApply() {
    reTried = true;
    fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: CODE }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (!c) return; ss('t20club', null); readCart(c); try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } })); } catch (e) {} })
      .catch(function () {});
  }
  function readCart(cart) {
    var codes = (cart && cart.discount_codes) || [];
    hasCode = codes.some(function (d) { return String(d.code).toUpperCase() === CODE; });
    var withClub = clubInCart(cart);
    if (hasCode) ss('t20want', '1');
    if (ss('t20want') === '1' && withClub) ss('t20club', '1');
    if (!hasCode && !withClub && ss('t20club') === '1' && !reTried && cart && cart.item_count > 0 && !H.hasAttribute('data-gob-member')) reApply();
    if (!hasCode && !withClub && ss('t20club') !== '1') ss('t20want', null);
    ss('t20ap', hasCode ? '1' : null); paint();
    if (cart && typeof cart.total_discount === 'number') { lastSave = cart.total_discount; saveText(); }
  }
  var lastSave = 0;
  function saveText() { qa('.t20-chead-save').forEach(function (n) { n.textContent = lastSave > 0 ? ' · −' + money(lastSave) : ''; }); }
  function fetchCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(readCart).catch(function () {}); }
  paint(); fetchCart();
  ['cart:updated', 'cart:build', 'cart:refresh', 'ajaxProduct:added', 'CartDrawer:open'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var c = e && e.detail && e.detail.cart; if (c && c.discount_codes) readCart(c); else setTimeout(fetchCart, 200); });
  });
  document.addEventListener('gob:club-prices', paint);
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });

  /* Dual price: regular + sale printed side by side, CSS shows one (no flash). */
  function dual(c, sup, label) {
    return '<span class="t20-reg">' + money(c, sup) + (label ? '<em class="t20-hint">−20% with ' + CODE + '</em>' : '') + '</span>' +
           '<span class="t20-sale">' + money(off(c), sup) + '<s>' + money(c) + '</s></span>';
  }

  /* ---------- countdown ---------- */
  function parts() { var s = Math.max(0, Math.floor((END - Date.now()) / 1000)); return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 }; }
  function tick() {
    var p = parts();
    qa('[data-t20cd]').forEach(function (n) {
      n.innerHTML = n.getAttribute('data-t20cd') === 'boxes'
        ? [['d', 'Days'], ['h', 'Hrs'], ['m', 'Min'], ['s', 'Sec']].map(function (u) { return '<span>' + pad(p[u[0]]) + '<small>' + u[1] + '</small></span>'; }).join('')
        : p.d + 'd ' + pad(p.h) + 'h ' + pad(p.m) + 'm';
    });
  }

  /* ---------- B03 · hero ---------- */
  function hero() {
    var h = q('.gobh'); if (!h || h.classList.contains('t20')) return; h.classList.add('t20');
    var k = q('.gobh__kick', h); if (k) k.textContent = 'HALLOWEEN SALE · UNTIL 31 OCTOBER';
    var t = q('.gobh__h', h); if (t) t.innerHTML = 'Find your kit. <em>Light it for 20% less.</em>';
    var s = q('.gobh__sub', h); if (s) s.innerHTML = 'Light up your LEGO® set for Halloween. Every kit is <b>20% off with code ' + CODE + '</b> until 31 October. Search by set number or name to find yours.';
    var help = q('.gobh__help', h);
    if (help) help.parentNode.insertBefore(el('<div class="t20-heroline"><span class="t20-code">' + CODE +
      '<a class="t20-apply" href="' + applyUrl() + '">Apply code</a><span class="t20-okpill">Applied</span><span class="t20-clubpill">GOB Club 30% instead</span></span>' +
      '<span class="t20-cdcap">Ends in</span><span class="t20-cd" data-t20cd="boxes"></span></div>'), help);
    var media = q('.gobh__media', h);
    if (media && !q('.t20-sticker', media)) media.appendChild(el('<div class="t20-sticker">' + PK + '<span>Halloween · <b>−20%</b></span></div>'));
  }

  /* ---------- E01 · Mayor Manor leads the hero slider ---------- */
  function heroSlide(pr) {
    var slide = q('.gobh__slide'); var img = slide && q('img', slide); if (!img || img.dataset.t20 || !IMG.on) return;
    img.dataset.t20 = 1; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = IMG.on;
    img.alt = 'LEGO® Mayor Manor 11383 lit with a Game of Bricks kit'; img.style.objectPosition = '62% 50%';
    img.loading = 'eager';
    var cap = q('.gobh__cap');
    if (cap) cap.innerHTML = '<a href="' + ROOT + 'products/' + MANOR + '">Light Kit for Mayor Manor 11383</a>';
  }

  /* ---------- B04 · Explore by collection ---------- */
  function cats() {
    qa('.gobcat__t').forEach(function (t) { if (!q('.t20-tilepill', t)) t.appendChild(el('<span class="t20-tilepill">−20%</span>')); });
    var sec = q('[id*=gob_categories]'); if (!sec) return;
    var lead = qa('p', sec).find(function (x) { return /Browse over/.test(x.textContent); });
    if (lead && !lead.dataset.t20) { lead.dataset.t20 = 1; lead.innerHTML = 'Browse over 800 custom kits, each designed to light up one specific LEGO® set. <b>Every kit is 20% off with ' + CODE + ' until 31 October.</b>'; }
  }

  /* ---------- B05 · Halloween picks (kits row) ---------- */
  function kits() {
    var k = q('.gobkits'); if (!k || k.dataset.t20) return; k.dataset.t20 = 1; k.classList.add('t20');
    var e = q('.gobs__eyebrow', k); if (e) e.textContent = 'AFTER DARK · HALLOWEEN PICKS';
    var hh = q('.gobs__head', k); if (hh) hh.textContent = 'Built for a dark room.';
    var sb = q('.gobs__sub', k); if (sb) sb.textContent = 'Three builds that look their best with the lights off. All 20% off with ' + CODE + ' until 31 October.';
    var pill = q('.gobs__pill', k); if (pill) pill.innerHTML = 'Shop the Halloween sale <em aria-hidden="true">→</em>';
    qa('.gobkits__tile', k).forEach(function (tile) {
      var href = tile.getAttribute('href'); if (!href || href.indexOf('/products/') < 0) return;
      fetch(href.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (pr) {
        var tb = q('.gobkits__tb', tile); if (!tb || q('.t20-kprice', tb)) return;
        tb.appendChild(el('<span class="t20-kprice">' + dual(pr.price, false, true) + '</span>'));
      }).catch(function () {});
    });
  }

  /* ---------- E04 · Halloween card in the Shop menu ---------- */
  function mega() {
    var dd = q('#site-nav-item--2 .site-nav__dropdown'); if (!dd || q('.t20-mega', dd) || !IMG.on) return;
    dd.appendChild(el('<a class="t20-mega" href="' + ROOT + 'collections/lego-light-kits"><img src="' + IMG.on + '" alt="" loading="lazy"><span><b>Halloween sale · 20% off</b><span>Every kit with ' + CODE + ' until 31 October.</span><em>SHOP THE SALE →</em></span></a>'));
  }

  /* ---------- E05 · hero search suggestions ---------- */
  function searchSale() {
    var pop = q('#GobHeroResults'); if (!pop) return; var list = q('[data-gob-list]', pop); if (!list) return;
    if (!q('.t20-srhead', pop)) pop.insertBefore(el('<div class="t20-srhead"><span>Halloween prices</span><b>' + CODE + ' · −20%</b></div>'), pop.firstChild);
    var cache = {};
    function run() {
      qa('a.gobh__opt[href*="/products/"]', list).forEach(function (a) {
        if (a.dataset.t20) return; a.dataset.t20 = 1;
        var url = a.getAttribute('href').split('?')[0] + '.js';
        (cache[url] = cache[url] || fetch(url).then(function (r) { return r.json(); })).then(function (pr) {
          var sub = q('.t > span', a); var html = '<span class="t20-srp">' + dual(pr.price, false, true) + '</span>';
          if (sub) sub.outerHTML = html; else { var t = q('.t', a); if (t) t.insertAdjacentHTML('beforeend', html); }
        }).catch(function () {});
      });
    }
    run(); new MutationObserver(run).observe(list, { childList: true, subtree: true });
  }

  /* ---------- prices follow the code (cards + PDP), D2 ---------- */
  function wrapPrice(node, sup) {
    if (!node || q('.t20-reg', node)) return; var c = centsOf(node); if (!c) return;
    node.innerHTML = '<span aria-hidden="true">' + dual(c, sup, false) + '</span><span class="visually-hidden">' + money(c) + '</span>';
  }
  function cards(root) { qa('.gob-gp-off .grid-product__price--current', root).forEach(function (n) { wrapPrice(n, true); }); }
  function pdp() {
    var dp = q('.d-pl .d-price'); if (!dp) return; wrapPrice(dp, true);
    /* R01 · applied pill, shown only while TREAT20 is on the cart (CSS) */
    var tax = q('.d-pl .d-tax');
    if (tax && !q('.t20-okpdp')) tax.after(el('<span class="t20-okpdp"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + CODE + ' applied</span>'));
    if (!dp.dataset.t20o) { dp.dataset.t20o = 1; new MutationObserver(function () { if (!q('.t20-reg', dp)) wrapPrice(dp, true); }).observe(dp, { childList: true }); }
  }

  /* ---------- E20 · tab title + favicon ---------- */
  function tab() {
    var svg = 'data:image/svg+xml,' + encodeURIComponent(PK.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" '));
    qa('link[rel~="icon"]').forEach(function (l) { l.href = svg; l.type = 'image/svg+xml'; });
    var t = document.title;
    document.addEventListener('visibilitychange', function () { document.title = document.hidden ? 'Come back. 20% is waiting' : t; });
  }

  /* ---------- P02 · Light the manor popup ---------- */
  function popup() {
    if (hasCode || club() || ls('t20pop') === '1' || !IMG.on || !IMG.off) return;
    if (/\/(cart|checkouts?|account|apps\/parcelpanel)/.test(location.pathname)) return;
    var shown = false;
    function open() {
      if (shown || hasCode || club()) return; shown = true; ls('t20pop', '1');
      window.removeEventListener('scroll', onScroll); clearTimeout(rt);
      var o = el('<div class="t20-ov" role="dialog" aria-modal="true" aria-label="Halloween offer"><div class="t20-pop">' +
        '<button class="t20-x" type="button" aria-label="Close">×</button>' +
        '<div class="t20-im"><img class="t20-off" src="' + IMG.off + '" alt="LEGO® Mayor Manor with the lights off"><img class="t20-lit" src="' + IMG.on + '" alt="LEGO® Mayor Manor lit with a Game of Bricks kit"></div>' +
        '<div class="t20-c"><div class="t20-s1"><div class="t20-k">Trick or treat</div><h3 class="t20-h">Turn on the lights at Mayor Manor.</h3><p class="t20-p">Flip the switch. Something is waiting inside.</p><button class="t20-btn t20-go" type="button">Lights on</button><div class="t20-fine">Everyone gets the same treat. No catch.</div></div>' +
        '<div class="t20-s2"><div class="t20-k">The manor is awake</div><h3 class="t20-h">20% off. Every kit.</h3><p class="t20-p">Light up your LEGO® set for 20% less, until 31 October.</p>' +
        '<div class="t20-big">' + CODE + '<a href="' + applyUrl() + '">Apply code</a></div>' +
        '<a class="t20-ghost" href="' + applyUrl(ROOT + 'products/' + MANOR) + '">Shop Mayor Manor</a><div class="t20-fine">Ends in <span data-t20cd="short"></span> · not combined with GOB Club</div></div></div></div></div>');
      document.body.appendChild(o); tick();
      function close() { o.remove(); document.removeEventListener('keydown', esc); }
      function esc(e) { if (e.key === 'Escape') close(); }
      o.addEventListener('click', function (e) { if (e.target === o || e.target.closest('.t20-x')) close(); });
      document.addEventListener('keydown', esc);
      q('.t20-go', o).addEventListener('click', function () { o.classList.add('lit'); var a = q('.t20-big a', o); if (a) a.focus(); });
      q('.t20-go', o).focus();
    }
    /* V152 popup budget: one interruption per visit (window.GOBPop, gob-smooth.js),
       never while the cart drawer is open or just after an add to cart, and
       never over the buy box — on a product page it waits until the shopper has
       scrolled past Add to cart (not on the 8 s timer while they look at photos). */
    var rt = 0;
    function blocked() {
      var P = window.GOBPop;
      if (P && !P.free('t20')) return 'taken';
      if (P && P.busy()) return 'busy';
      var b = document.querySelector('.gobd1 .d-atc, [data-add-to-cart]');
      /* product page: only once the shopper has scrolled past Add to cart */
      if (b) { var r = b.getBoundingClientRect(); if (r.width && r.bottom > 0) return 'buybox'; }
      return '';
    }
    function tryOpen() {
      if (shown) return;
      var why = blocked();
      if (why === 'taken') { window.removeEventListener('scroll', onScroll); clearTimeout(rt); return; }
      if (why) { clearTimeout(rt); rt = setTimeout(tryOpen, 4000); return; }
      if (window.GOBPop) window.GOBPop.take('t20');
      open();
    }
    function onScroll() { var d = document.documentElement; if ((d.scrollTop + innerHeight) / d.scrollHeight > 0.4) tryOpen(); }
    rt = setTimeout(tryOpen, 8000); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* H01 · Halloween Light Kits in the collection sidebar (desktop + mobile Filter drawer) */
  function sidebar() {
    var here = /\/collections\/halloween\/?$/.test(location.pathname);
    qa('ul.sidebar-list-categories').forEach(function (ul) {
      if (q('.t20-sidecat', ul) || !ul.children.length) return;
      ul.children[0].after(el('<li class="sidebar-cat-item t20-sidecat' + (here ? ' active' : '') + '"><a class="js-no-transition' + (here ? ' active' : '') + '" href="' + ROOT + 'collections/halloween">' + PK + 'HALLOWEEN LIGHT KITS</a></li>'));
    });
  }

  /* C10A · Halloween cart header (only while TREAT20 is on the cart, via CSS) */
  function cartHead() {
    var hd = q('#HeaderCart .gob-drawer-head'); if (!hd || q('.t20-chead', hd.parentNode)) return;
    var h = el('<div class="t20-chead">' + (IMG.on ? '<img src="' + IMG.on + '" alt="">' : '') + '<div class="t"><b>Your Halloween cart</b><span class="ok"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + CODE + ' applied<span class="t20-chead-save"></span></span></div><button type="button" class="x" aria-label="Close cart">✕</button></div>');
    /* V162: sits under the drawer's own header, which stays visible with its close button */
    hd.parentNode.insertBefore(h, hd.nextSibling); saveText();
    q('.x', h).addEventListener('click', function () { var c = q('.gob-drawer-close', hd); if (c) c.click(); });
  }
  function watchCart() { var c = q('#HeaderCart'); if (!c) return; cartHead(); new MutationObserver(function () { cartHead(); }).observe(c, { childList: true, subtree: true }); }

  /* B10 · top bar: three rotating Halloween lines replace the usual messages */
  function topBar() {
    var roll = q('.gobann .gobann__roll'); if (!roll || roll.classList.contains('t20-bar')) return;
    roll.classList.add('t20-bar');
    var D = '<i class="d"></i>';
    roll.innerHTML = '<div class="t20-rot"><div class="t20-bl">' + PK + '<b>20% off every kit</b>' + D + '<span>Code <b class="a">' + CODE + '</b></span></div>' +
      '<div class="t20-bl"><span>Light up your LEGO® set for Halloween</span></div>' +
      '<div class="t20-bl"><span>Ends 31 October at midnight</span>' + D + '<span class="cd" data-t20cd="short"></span></div></div>';
  }

  /* ---------- boot ---------- */
  function boot() {
    topBar(); hero(); cats(); kits(); mega(); sidebar(); watchCart(); searchSale(); cards(); pdp(); tab(); tick(); setInterval(tick, 1000);
    var g = q('.new-grid.product-grid, #CollectionAjaxContent'); if (g) new MutationObserver(function () { cards(g); }).observe(g, { childList: true, subtree: true });
    if (q('.gobh__slide')) heroSlide();
    popup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
